export default __webpack_public_path__ + "static/media/rebutia_krainziana.505e943b.jpg";